import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc"
  }
};
import { computed, shallowRef, onBeforeUnmount } from "vue";
import "@wangeditor/editor/dist/css/style.css";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import baseURL from "@/config/base-url";
const mode = "simple";
export default /*#__PURE__*/_defineComponent({
  __name: 'wang-editor',
  props: {
    modelValue: {},
    height: {
      default: 550
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const valueHtml = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      }
    });
    const editorRef = shallowRef();
    const toolbarConfig = {};
    const uploadFileUrl = baseURL + "/uploadFile";
    const editorConfig = {
      MENU_CONF: {}
    };
    editorConfig.MENU_CONF["uploadImage"] = {
      server: uploadFileUrl,
      maxFileSize: 2 * 1024 * 1024,
      fieldName: "file",
      // meta: {
      //   source: "sys_user_guide",
      // },
      customInsert(res, insertFn) {
        insertFn(res.data.bucket_path, res.data.name, res.data.bucket_path);
      }
    };
    editorConfig.MENU_CONF["uploadVideo"] = {
      server: uploadFileUrl,
      maxFileSize: 30 * 1024 * 1024,
      fieldName: "file",
      // meta: {
      //   source: "sys_user_guide",
      // },
      customInsert(res, insertFn) {
        insertFn(res.data.bucket_path, res.data.name, res.data.bucket_path);
      }
    };
    onBeforeUnmount(() => {
      const {
        value
      } = editorRef;
      if (value === null) return;
      value.destroy();
    });
    const handleCreated = editor => {
      editorRef.value = editor;
      if (props?.modelValue) {
        editor.setHtml(props.modelValue);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
        style: {
          "border-bottom": "1px solid #ccc"
        },
        editor: editorRef.value,
        defaultConfig: toolbarConfig,
        mode: mode
      }, null, 8, ["editor"]), _createVNode(_unref(Editor), {
        style: {
          "height": "500px",
          "overflow-y": "hidden"
        },
        modelValue: valueHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => valueHtml.value = $event),
        defaultConfig: editorConfig,
        mode: mode,
        onOnCreated: handleCreated
      }, null, 8, ["modelValue"])]);
    };
  }
});